var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPersonalInfoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1868 28.8266C23.0135 29.1733 21.6268 29.3333 20.0001 29.3333H12.0001C10.3735 29.3333 8.98681 29.1733 7.81348 28.8266C8.10681 25.36 11.6668 22.6266 16.0001 22.6266C20.3335 22.6266 23.8935 25.36 24.1868 28.8266Z",
    stroke: "#10182F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 2.66666H11.9998C5.33317 2.66666 2.6665 5.33332 2.6665 12V20C2.6665 25.04 4.1865 27.8 7.81317 28.8267C8.1065 25.36 11.6665 22.6266 15.9998 22.6266C20.3332 22.6266 23.8932 25.36 24.1865 28.8267C27.8132 27.8 29.3332 25.04 29.3332 20V12C29.3332 5.33332 26.6665 2.66666 19.9998 2.66666ZM15.9998 18.8933C13.3598 18.8933 11.2265 16.7467 11.2265 14.1067C11.2265 11.4667 13.3598 9.33332 15.9998 9.33332C18.6398 9.33332 20.7732 11.4667 20.7732 14.1067C20.7732 16.7467 18.6398 18.8933 15.9998 18.8933Z",
    stroke: "#10182F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonalInfoBlack);
export default __webpack_public_path__ + "static/media/ic-personal-info-black.d5f227474f2d1b533ce518075c537d86.svg";
export { ForwardRef as ReactComponent };